<template>
    <div>
        <div class="nc_comm_banner">
            <div class="banner">
                <img :src="src">
            </div>
            <div class="w">
                <div class="banner_content">
                    <h1>{{h1}}</h1>
                    <slot></slot>
                </div>              
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['src','h1']
}
</script>

<style scoped lang='less'>
    .nc_comm_banner{
        width: 100%;
        height: 500px;
        padding-top: 170px;
        overflow: hidden;
        position: relative;
        .banner_content{
            width: 100%;
            color: #eee;
            h1{
                font-size: 40px;
                font-weight: 100;
                margin-bottom: 22px;
            }
            p{
                font-size: 16px;
                margin-bottom: 8px;
            }
        }

        .banner{
            width: 1920px;
            position: absolute;
            left: 50%;
            top: 0;
            margin-left:-960px;
            z-index: -1;
            
        }
    }
</style>